$(document).ready(function () {
  var $form = $('div#form-wrapper').find('form:first');

  if ($form.length === 0) {
    $form = $('div.main-content:first').find('form:first');

    if ($form.length === 0) {
      return;  
    }
  }

  if ($form.data("validator")) {
    $form.data("validator").settings.ignore = "input[type=hidden]";
  }
});